// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import cn from 'classnames';
import store from '../../store.js';
import {Text} from '../../comp/text';
import {Icon} from '../../comp/icon';
import {TH, TR, TD, Table} from '../../comp/table';
import {FAQ_LINK_REFERRAL} from '../../utils/constants.js';
import {fmt_money} from '../../utils/misc.js';
import * as cns from './table.module.less';

const get_valid_icon = referee=>{
    const {ico, color, tip} = {
        some_ips_match: {
            color: 'warning',
            ico: 'warn',
            tip: <span>Partial earnings, 1 or more devices share your IP
              address, <a target="_blank" rel="noreferrer noopener"
                href={FAQ_LINK_REFERRAL}>why</a>?
            </span>,
        },
        all_ips_match: {
            color: 'error',
            ico: 'close',
            tip: <span>Not earning, you both share the same
              IP - <a target="_blank" rel="noreferrer noopener"
                href={FAQ_LINK_REFERRAL}>learn more</a>
            </span>,
        },
    }[referee.error] || {color: 'success', ico: 'success', tip: null};
    return <Icon tip={tip} tip_placement="top" ico={ico} color={color}/>;
};

function Table_header(){
    return <>
      <TH left>Email</TH>
      <TH>Earned</TH>
      <TH>Total</TH>
      <TH>Valid referral</TH>
    </>;
}

function Row({data: i, referral_part}){
    return <TR className={cns.row}>
      <TD left>
        <Text.s no_wrap>{i.email}</Text.s>
      </TD>
      <TD>
        <Text.s mono no_wrap>{fmt_money(i.bonuses)}</Text.s>
      </TD>
      <TD>
        <Text.s mono no_wrap>{fmt_money(i.bonuses_total)}</Text.s>
      </TD>
      <TD>{get_valid_icon(i)}</TD>
    </TR>;
}

export function Referees_table({list, loading, pagination, className}){
    const [{referral_part}] = store.use_money();
    const render_row = useCallback(t=>
        <Row data={t} referral_part={referral_part}/>,
        [referral_part]);
    return <div className={cn(cns.root, className)}>
      <Table header={<Table_header/>} list={list} loading={loading}
        render_row={render_row} id_key="id" pagination={pagination}/>
    </div>;
}
